import { useEffect } from 'react';

export function useViewportHeights(headerRef, inputRef) {
  useEffect(() => {
    const root = document.documentElement;
    const applyHeights = () => {
      if (headerRef.current) root.style.setProperty('--header-h', `${headerRef.current.getBoundingClientRect().height}px`);
      if (inputRef.current)  root.style.setProperty('--input-h',  `${inputRef.current.getBoundingClientRect().height}px`);

      const vv = window.visualViewport;
      const vvHeight = vv ? vv.height : window.innerHeight;
      const kbOverlap = vv ? (window.innerHeight - (vv.height + vv.offsetTop)) : 0;
      root.style.setProperty('--vvh', `${vvHeight}px`);
      root.style.setProperty('--kb', `${Math.max(0, kbOverlap)}px`);
    };
    applyHeights();
    const vv = window.visualViewport;
    vv?.addEventListener('resize', applyHeights);
    vv?.addEventListener('scroll', applyHeights);
    window.addEventListener('resize', applyHeights);
    window.addEventListener('orientationchange', applyHeights);
    return () => {
      vv?.removeEventListener('resize', applyHeights);
      vv?.removeEventListener('scroll', applyHeights);
      window.removeEventListener('resize', applyHeights);
      window.removeEventListener('orientationchange', applyHeights);
    };
  }, [headerRef, inputRef]);

  useEffect(() => {
    const root = document.documentElement;
    const apply = () => {
      if (headerRef.current) root.style.setProperty('--header-h', `${headerRef.current.getBoundingClientRect().height}px`);
      if (inputRef.current)  root.style.setProperty('--input-h',  `${inputRef.current.getBoundingClientRect().height}px`);
    };
    apply();
  });
}
